import { createContext } from 'react';

// ⭐ Fichier dédié au Context uniquement - pas de composant React
export const IdleTimerContext = createContext(null);